import { subtitleTypes } from '@/mocks/filmData';

export default function SubtitleTypes() {
  return (
    <section id="subtitles" className="scroll-mt-20 bg-background-50">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
            <i className="ri-film-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-primary-700 uppercase">Subtitle</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">字幕与语言版本类型</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          同一部作品会以多种语言形式出现。以下六种是检索中最常见的类型，每种对应的使用场景并不相同，可以按需选择。
        </p>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {subtitleTypes.map((item) => (
            <article
              key={item.name}
              className="group rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 p-5 transition-colors"
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 rounded-md bg-background-100 text-primary-600 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="px-2 py-0.5 rounded-full text-[11px] bg-accent-100 text-accent-900">{item.tag}</span>
              </div>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{item.name}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}